import {get, post} from 'external/axios';

export class OfferService {
	async getOffers() {
		return get('/offer/all');
	}

	async getActiveOffers() {
		return get('/offer/all/actives');
	}

	async getOffersById(id) {
		return get(`/offer/${id}`);
	}

	async getOffersSubjectsById(id) {
		return get(`/offer/subjects/${id}`);
	}

	async getOffersSummary() {
		return get('/offer/summary/list');
	}

	async createOffer(request) {
		return post('/offer/create', request);
	}

	async updateOffer(request) {
		return post('/offer/update', request);
	}

	async updateOfferActive(request) {
		return post('/offer/updateActive', request);
	}

	async updateCustomNameOffer(request) {
		return post('/offer/updateCustomNameOffer', request);
	}
}

export const offerService = new OfferService();